import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-TA-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 272.02 190.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-TA-logo_svg__cls-1{fill:#d9002d;fill-rule:evenodd}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M198.52 35.57C166.24 29.56 133.34 16.83 106.33 0c3.56 31.59 68.62 37.64 92.19 35.57Z",
      style: {"fill":"#5e0e24","fill-rule":"evenodd"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M148.5 47.26c13.99.38 53.18-4.65 63.52-9.12-28.77 1.81-44.12 2.28-60.86.74-16.73-1.54-31.22-1.15-54.21-8.14 6.22 14.16 33.43 16.52 51.55 16.52ZM122.56 71.59c3.11 8.29 51.28-11.74 54.98-13.19 5.27-2.06 45.64-19.32 49.61-19.74-5.81-1.37-41.41 10.36-62.23 17.18-5.95 1.95-38.41 13.88-42.36 15.75ZM158.1 100.13c9.49-2.97 32.28-17.95 56.48-31.61 20.69-11.66 42-22.14 57.44-17.34.1-37.83-111.59 45.75-113.92 48.94Z",
      class: "svg-TA-logo_svg__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M256.84 38.67c-25.07-3.24-73.62 22.57-121.04 56.86C84.51 135.2 23.26 177.31 0 190.58c19.02-5.17 79.29-34.66 137.28-82.26 63.43-48.28 90.82-64.42 119.56-69.65ZM32.56 146.76c16.54 1.45 36.53-8.71 63.97-27.48 30.4-20.78 58.16-40.29 62.26-44.71-5.31 2.75-35.45 21.46-64.98 38.52-29.53 17.06-59.4 31.15-61.25 33.67Z",
      class: "svg-TA-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TA-logo"}) } }